import { useEffect } from 'react';

const useSpacebarRelease = (callback: () => void) => {
    useEffect(() => {
        const handleKeyUp = (event: KeyboardEvent) => {
            if (event.code === 'Space') {
                callback();
            }
        };

        window.addEventListener('keyup', handleKeyUp);

        // Clean up the event listener
        return () => {
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [callback]);
};

export default useSpacebarRelease;
